module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-book"
    }
  }, [_c('h1', [_vm._v("About the Book")]), _vm._v(" "), _c('p', [_c('em', [_vm._v("The Gatekeeper/s")]), _vm._v(" blends realism and idealism in a novel way. The style is also unusual in that it moves from rhetorical dialogue to emphatic storytelling. The story is set against a legal system based on seeking consent between parties involved in a negotiation, rather than regarding one party wrong and the other right, as in the old legal system. Rhetoricians are the ones expected to obtain consent from people and they act on behalf of GAIC (Global Authority for Informed Consent) and its negotiators. The main rhetorician is Toni Forti. Achilles is the main negotiator. There are two groups of children interacting with GAIC. In the first part of the story, three children separately challenge the new informed consent to achieve self-determination. In the second part of the story, four children use the system to achieve justice.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cbc7d7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0